module.exports = __webpack_public_path__ + "static/Logo-InnovationLab_White-3e089baa311d99fd6078ba290879f0bb.svg";